import EmblaCarousel from "embla-carousel";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function setActiveSlide(embla) {
  embla.slideNodes().forEach((slide, index) => {
    slide.classList.toggle("is-active", index === embla.selectedScrollSnap());
  });
}

function ignoreClickAfterDrag(viewport) {
  let startX = 0;
  let startY = 0;
  let dragged = false;

  viewport.addEventListener("pointerdown", (event) => {
    startX = event.clientX;
    startY = event.clientY;
    dragged = false;
  });

  viewport.addEventListener("pointermove", (event) => {
    if (
      Math.abs(event.clientX - startX) > 6 ||
      Math.abs(event.clientY - startY) > 6
    ) {
      dragged = true;
    }
  });

  viewport.addEventListener(
    "click",
    (event) => {
      if (!dragged) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
}

function initPropertyGallery(root) {
  const viewport = root.querySelector(".property-gallery__viewport");
  const prevButton = root.querySelector(".property-gallery__nav--prev");
  const nextButton = root.querySelector(".property-gallery__nav--next");
  const slides = viewport?.querySelectorAll(".property-gallery__slide") ?? [];

  if (viewport) {
    ignoreClickAfterDrag(viewport);
  }

  if (!viewport || slides.length < 2) {
    prevButton?.setAttribute("hidden", "hidden");
    nextButton?.setAttribute("hidden", "hidden");
    return;
  }

  const embla = EmblaCarousel(viewport, {
    align: "center",
    loop: true,
    containScroll: false,
  });

  const syncSlides = () => {
    setActiveSlide(embla);
  };

  embla.on("init", syncSlides);
  embla.on("reInit", syncSlides);
  embla.on("select", syncSlides);

  prevButton?.addEventListener("click", () => {
    embla.scrollPrev();
  });

  nextButton?.addEventListener("click", () => {
    embla.scrollNext();
  });

  syncSlides();
}

Fancybox.bind("[data-property-gallery]", "[data-fancybox]", {
  groupAttr: "data-fancybox",
});

document
  .querySelectorAll("[data-property-gallery]")
  .forEach(initPropertyGallery);
